import React from "react";
import TeamSuccessImg from "../Assets/TeamSuccessImg.png";
import { Link } from "react-router-dom";

export default function TeamMatchingSuccessPage() {
  return (
    <div className="flex items-center justify-center flex-col gap-3 h-[100vh]">
      <img src={TeamSuccessImg} />
      <p className="text-[1.1rem] font-[600]">MATCHING COMPLETED!</p>
      <p className="text-[0.94rem] text-[#6B7280]">
        Project (insert Name of the Project) has been assigned to Team (insert
        Name of the team).
      </p>
      <p className="text-[0.94rem] text-[#6B7280]">
        Team Members will be notified to assign their individual tasks.
      </p>
      <Link to="/workspace" >
      <button className="w-[15rem] h-[2.3rem] text-[0.90rem] text-white bg-[#942A27] rounded-[8px] mt-3">
        GO BACK TO WORKSPACE
      </button>
      </Link>
    </div>
  );
}
